import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { HttpLoaderService } from '../services/http-loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
    const hpptLoaderService = inject(HttpLoaderService);
    hpptLoaderService.showLoader();
    return next(req).pipe(finalize(() => hpptLoaderService.hideLoader()));
};
